
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {GetMedicalCertificateResponse} from "@/api-client";

    @Component
    export default class MedicalCertificateResponse extends Vue{
        @Prop({required: true})
        details!: GetMedicalCertificateResponse;
    }
